module.exports = __webpack_public_path__ + "img/office-managment.e74fa05b.svg";